<template>
  <div class="row">

    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <!-- Nav tabs -->
          <ul class="nav nav-tabs customtab" role="tablist">
            <li class="nav-item">
              <a class="nav-link" v-bind:class="{active: activeTab === 'active'}" @click="activeTab = 'active'">
                <span>{{ $t("Active actions")}}</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" v-bind:class="{active: activeTab === 'history'}" @click="activeTab = 'history'">
                <span>{{ $t("Finished") }}</span>
              </a>
            </li>
            <li class="nav-item filter-tab">
            </li>
            <li class="nav-item filter-tab">
              <button type="button" class="btn btn-rounded btn-info mr-3" @click="showModal = !showModal"><i class="ti-plus"></i> {{ $t('Add action') }}</button>

              Show

              <div class="btn-group dropdown-group">
                <button class="btn btn-secondary btn-rounded dropdown-toggle dropdown-button" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ pageAmount }} results
                </button>
                <div class="dropdown-menu dropdown-menu-custom">
                  <span class="dropdown-item text-info" v-on:click="changePageAmount(10)">10 results</span>
                  <a class="dropdown-item text-info" v-on:click="changePageAmount(25)">25 results</a>
                  <a class="dropdown-item text-info" v-on:click="changePageAmount(50)">50 results</a>
                </div>
              </div>

              <input class="btn btn-rounded btn-light margin-top" v-model="filterValue" @keyup="updateFilter" :placeholder="$t('Search actions')"/>
            </li>
          </ul>
          <!-- Tab panes -->
          <div class="tab-content">
            <div class="tab-pane active" v-show="activeTab === 'active'">
              <div :key="tableKey" class="table-responsive m-t-20">
                <table-component :data="fetchTableData" sort-by="date_end" sort-order="asc" class="actions-table table-not-searchable" ref="actionsTable" @rowClick="rowClicked">
                  <table-column label="" show="icon" :formatter="iconFormatter" :sortable="false"></table-column>
                  <table-column :label="$t('Action')" show="title"></table-column>
                  <table-column :label="$t('Due date')" show="date_end" cell-class="table-data d-none d-sm-table-cell" header-class="d-none d-sm-table-cell" :formatter="dateFormatter"></table-column>
                  <table-column :label="$t('Status')" cell-class="table-data d-none d-sm-block" header-class="d-none d-sm-block">
                    <template slot-scope="row">
                      {{ statusFilter(row.status) }}
                    </template>
                  </table-column>
                  <table-column label=" " :sortable="false" :filterable="false">
                    <template slot-scope="row">
                      <router-link :to="'/action/' + row.uid">
                        {{ $t("Details") }}
                      </router-link>
                    </template>
                  </table-column>
                </table-component>
              </div>

            </div>
            <div class="tab-pane active" v-show="activeTab === 'history'">
              <div class="table-responsive m-t-20">

                <table-component :data="fetchTableHistoryData" sort-by="date_end" sort-order="desc" class="actions-table table-not-searchable" ref="historyTable" @rowClick="rowClicked">
                  <table-column label="" show="icon" :formatter="iconFormatter" :sortable="false"></table-column>
                  <table-column :label="$t('Action')" show="title"></table-column>
                  <table-column :label="$t('Due date')" show="date_end" cell-class="table-data d-none d-sm-table-cell" header-class="d-none d-sm-table-cell" :formatter="dateFormatter"></table-column>
                  <table-column :label="$t('Status')" cell-class="table-data d-none d-sm-table-cell" header-class="d-none d-sm-table-cell">
                    <template slot-scope="row">
                      {{ statusFilter(row.status) }}
                    </template>
                  </table-column>
                  <table-column label=" " :sortable="false" :filterable="false">
                    <template slot-scope="row">
                      <router-link :to="'/action/' + row.uid">
                        {{ $t("Details") }}
                      </router-link>
                    </template>
                  </table-column>
                </table-component>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <add-action-modal v-if="showModal" @close="showModal = false" v-on:actionAdded="addAction"></add-action-modal>
  </div>
</template>

<script>
  import apiHelper from "../mixins/APIHelper";
  import AddActionModal from './AddActionModal';
  let PAGE_AMOUNT = 15;

  export default {
    name: "actions",
    components: {
      "add-action-modal": AddActionModal
    },
    data: function () {
      return {
        pageAmount: 10,
        filterValue: "",
        activeTab: "active",
        actions: [],
        finishedActions: [],
        paginationSettings: {
          totalPages: 0,
          currentPage: 0
        },
        historyPaginationSettings: {
          totalPages: 0,
          currentPage: 0
        },
        showModal: false,
        tableKey: 0
      }
    },
    methods: {
      rowClicked: function ($event) {
        this.$router.push('/action/' + $event.data.uid);
      },
      changePageAmount(amount){
        this.pageAmount = amount;
        this.$refs.actionsTable.refresh();
        this.$refs.historyTable.refresh();
      },
      updateFilter(){
        this.$refs.actionsTable.filter = this.filterValue;
        this.$refs.historyTable.filter = this.filterValue;
      },

      addAction(data){

      },

      filterAndSort(data, filter, sortObj){
        let output = [];
        // First filter
        for (let i = 0; i < data.length; i++) {
          let item = data[i];

          let added = false;
          for(let key in item){
            // Disregard prototype properties
            if(!item.hasOwnProperty(key)) continue;

            if(item[key] !== null && item[key].toString().toLowerCase().includes(filter.toLowerCase()) && !added){
              output.push(item);
              added = true;
            }
          }
        }

        // Then sort:
        output.sort(this.sortByProperty(sortObj.fieldName, sortObj.order));
        return output;
      },

      sortByProperty(property, direction){
        let directionCoeff = direction === "asc" ? 1 : -1;

        return function (a, b) {
          let sortA = (a[property] === null || typeof a[property] === 'undefined') ? a[property] : a[property].toLowerCase();
          let sortB = (b[property] === null || typeof b[property] === 'undefined') ? b[property] : b[property].toLowerCase();

          if(sortA < sortB) {
            return -1 * directionCoeff;
          }

          if(sortA > sortB){
            return directionCoeff;
          }
          return 0;
        }
      },

      statusFilter(status) {
        return this.$options.filters.ucFirst(this.$t(status));
      },

      async fetchTableData({page, filter, sort}) {
        let PAGE_AMOUNT = this.pageAmount;
        if (this.actions.length < 1) {
          const response = await apiHelper.getResource("/api/user/{uid}/actions", {history: "0"});
          this.actions = response;
          this.paginationSettings.totalPages = Math.ceil(response.length / PAGE_AMOUNT);
          this.paginationSettings.currentPage = page;
        }
        let sortedActions = this.filterAndSort(this.actions, filter, sort);
        let pageData = sortedActions.slice((page - 1) * PAGE_AMOUNT, page * PAGE_AMOUNT);
        let paginationData = {
          totalPages: this.paginationSettings.totalPages,
          currentPage: page
        };

        for (let i = 0; i < pageData.length; i++) {
          pageData[i]["icon"] = pageData[i].status;
        }


        return {data: pageData, pagination: paginationData};
      },
      async fetchTableHistoryData({page, filter, sort}) {
        let PAGE_AMOUNT = this.pageAmount;
        if (this.finishedActions.length < 1) {
          const response = await apiHelper.getResource("/api/user/{uid}/actions", {history: "1"});
          this.finishedActions = response;
          this.historyPaginationSettings.totalPages = Math.ceil(response.length / PAGE_AMOUNT);
          this.historyPaginationSettings.currentPage = page;
        }
        let filteredActions = this.filterAndSort(this.finishedActions, filter, sort);

        let pageData = filteredActions.slice((page - 1) * PAGE_AMOUNT, page * PAGE_AMOUNT);
        let paginationData = {
          totalPages: this.historyPaginationSettings.totalPages,
          currentPage: page
        };
        for (let i = 0; i < pageData.length; i++) {
          pageData[i]["icon"] = pageData[i].status;
        }
        return { data: pageData, pagination: paginationData };
      },
      iconFormatter: function (value, rowProperties) {
        let icon = "";

        switch (value) {
          case 'done':
            icon = '<i class="ti-check text-success"></i>';
            break;
          case 'accept':
            icon = '<i class="ti-more-alt text-info"></i>';
            break;
          case 'declined':
            icon = '<i class="ti-close text-danger"></i>';
            break;
          case 'pending':
            icon = '<i class="ti-settings text-info"></i>';
            break;
        }

        return icon;
      },

      dateFormatter: function(value, rowProperties){
        return moment(value).format("D-M-YYYY");
      },

      statusFormatter: function (value, rowProperties) {
        return this.iconFormatter(value, rowProperties) + " " + value;
      }
    }
  }
</script>

<style>
  .table-component__table__body > tr > td{
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 15px;
  }

  .table-component__table__body > tr > td > i{
    font-size: 20px;
  }

  .table-component__table__body > tr:nth-child(even){
    background-color: #f5f7fb;
  }

  .filter-tab{
    margin-left: auto;
    height: 60px;
    margin-bottom: 10px !important;
  }

  .filter-tab > input {
    border-color: #ddd;
    text-align: left;
    font-weight: 600;
  }

  .filter-tab > input :hover {
    color: initial !important;
    background-color: initial !important;
    border-color: initial !important;
  }

  .num-results-select{
    border-radius: 60px !important;
    background-color: #64728c !important;
    color: white;
    height: 50px;
    padding-left: 5px;
    margin-right: 10px;
    margin-left: 5px;
  }
  .table-data{
    color: #647389;
  }

  ul.pagination > li:not(.page-item){
    padding: 8px;
  }

  .dropdown-button {
    background-color: #64748d;
    color: white;
  }

  .dropdown-group {
    margin-right: 10px;
    margin-left: 10px;
  }

  .dropdown-item {
    font-weight: bold;
  }

  .dropdown-menu-custom {
    position: absolute;
    transform: translate3d(0px, -130px, 0px);
    top: 5px !important;
    left: 7px !important;
    will-change: transform;
    border-radius: 10px !important;
    min-width: initial !important;
  }

  .pagination {
    margin-top: 1.5rem;
  }

  @media screen and (max-width: 768px){
    .filter-tab{
      margin-top: 8px;
    }
    .margin-top{
      margin-top: 8px;
    }
    ul.nav-tabs{
      padding-bottom: 16px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Actions.vue